<template>
  <div>
    <div class="title-and-choice">
      <!-- 标题 -->
      <span class="title">{{title}}</span>

      <!-- 按钮 -->

      <el-link class="choice-button-style"
               v-if="choice_visbale_prop"
               @click="choiceButtonClick"
               :underline="false"
               style="float:right; padding-left:5px"
               type="info"
               icon="el-icon-sort">修改</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="cancleButtonClick"
               :underline="false"
               style="padding-left:5px"
               type="info">取消</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="saveButtonClick"
               :underline="false"
               type="info"
               icon="el-icon-folder-checked">保存</el-link>
      <!-- 内容展示 -->
      <div>
        <div v-if="show_content_visable_prop"
             class="choice_show_area"
             v-html="content"></div>
        <!-- 选择器 -->
        <div class="input">
          <!-- 对话框 -->

          <div v-if="show_input_prop"
               :class="{class_name_one:false,class_name_two:true}">
            <el-table :data="refundData">
              <el-table-column label="当前方案"
                               width="80px">
                <template slot-scope="scope">
                  <el-radio-group v-model="sku_refund_id_prop">
                    <el-radio @change="checkboxChange"
                              :label="scope.row.id">
                      <span></span>
                    </el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="id"
                               label="方案编号"
                               width="80px"></el-table-column>
              <el-table-column prop="refund_info"
                               label="退改方案描述"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '..//editor/editorV1'
export default {
  name: 'input-modify',
  components: {
    'editor-area': Editor,
  },
  data() {
    return {
      info: '',
      is_editor: '',
      choice_visbale_prop: this.edit_visable,
      save_visable_prop: this.save_visable,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      // 输入组件
      input_textarea_width: '300px',
      input_text: this.input_text_content,
      input_textares: '',
      content: this.show_content,
      sku_refund_id_prop: this.sku_refund_id,

      // refundData_prop: this.refundData //数据内容
      // refundData_prop: [{ id: 1, refund_info: 20 }]
    }
  },
  props: {
    title: String,
    show_content: String, // sku介绍中显示当前的退改原则
    sku_refund_id: Number, // 当前退改的ID
    refundData: Array, //列表数据
    input_textares_width: String,
    attribuite: Number,
    // 样式
    // input_width: String,
    type: String,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.innerHTML);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },

    // 点击更改时的 方法
    choiceButtonClick() {
      this.save_visable_prop = true
      this.choice_visbale_prop = false
      this.show_input_prop = true
      this.show_content_visable_prop = false
      this.editor_content = this.show_content
      //   console.log("编辑" + this.editor_content);
      //   this.$emit("change",this.)
      this.$emit('choice')
    },
    saveButtonClick() {
      this.save_visable_prop = false
      this.choice_visbale_prop = true
      this.show_input_prop = false
      this.show_content_visable_prop = true
      // console.log(this.input_text);
      let sku_id = this.$emit('save', this.input_text, this.attribuite)
      // 发送修改退改原则的请求
      this.$http
        .post('/product/sku/add_refund_rule', {
          sku_id: this.attribuite,
          refund_id: this.sku_refund_id_prop,
        })
        .then((res) => {
          if (res.data.errno == '0') {
            this.content = res.data.data
            this.$notify({
              title: '成功',
              message: res.data.errmsg,
              type: 'success',
            })
          }
        })
    },
    // 取消编辑
    cancleButtonClick() {
      this.save_visable_prop = false
      this.choice_visbale_prop = true
      this.show_input_prop = false
      this.show_content_visable_prop = true
    },
    // 选择框变化
    checkboxChange(item) {
      // console.log(item);
    },
    // 监听改变值
    content_change(content) {
      this.editor_content = content
    },
  },
}
</script>

<style>
.title-and-choice {
  padding: 10px;
  background-color: cornsilk;
  border: 1px solid cornsilk;
  border-radius: 5px;
}
.title-and-choice:hover .choice-button-style {
  display: inline;
}
.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.choice_show_area {
  /* cursor: pointer; */
  margin-top: 10px;
  white-space: pre-wrap;
  padding: 0px 10px;
  /*  */
}
.editor {
  margin-top: 10px;
}
.choice-button-style {
  display: none;
  font-size: 10px;
}
.save-button-style {
  font-size: 10px;
}
/* v-bind 绑定两种class */
.class_name_one {
  width: 100px;
}
.class_name_two {
  width: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid whitesmoke;
}
</style>